import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ArenaIcon = ({ iconName, number, onClick, className }) => (
    <div className="arena__item__comments mr-4">
        <i className={classNames('icon mr-3', `icon--${iconName}`, className)} onClick={onClick} />
        <span>{number}</span>
    </div>
);

ArenaIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onClick: PropTypes.func,
};

ArenaIcon.defaultProps = {
    onClick: undefined,
    className: undefined,
};

export default ArenaIcon;



// WEBPACK FOOTER //
// ./src/components/arena/ArenaIcon.js